import React from 'react';
import { FaExclamationCircle } from 'react-icons/fa';

const REFUND_RETURNS_PATH = '/refund_returns';

const COPY = {
  delivery: {
    title: 'Review your order and address details to avoid cancellations',
    lead: 'Please ensure your address and order details are correct. This order, if cancelled, is non-refundable.',
  },
  pickup: {
    title: 'Review your order and contact details before you pay',
    lead: 'Please ensure your order and contact details are correct. This order, if cancelled, is non-refundable.',
  },
};

/**
 * @param {{ fulfillmentType: 'delivery' | 'pickup' }} props
 */
const CheckoutOrderReviewNotice = ({ fulfillmentType }) => {
  const copy = fulfillmentType === 'pickup' ? COPY.pickup : COPY.delivery;

  return (
    <aside
      className="checkout-order-review"
      role="note"
      aria-labelledby="checkout-order-review-title"
    >
      <FaExclamationCircle className="checkout-order-review__icon" aria-hidden />
      <div className="checkout-order-review__content">
        <p id="checkout-order-review-title" className="checkout-order-review__title">
          {copy.title}
        </p>
        <p className="checkout-order-review__note">
          {copy.lead}{' '}
          <a
            href={REFUND_RETURNS_PATH}
            target="_blank"
            rel="noopener noreferrer"
            className="checkout-order-review__link"
          >
            Refund &amp; returns policy
          </a>
        </p>
      </div>
    </aside>
  );
};

export default CheckoutOrderReviewNotice;
